var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 9.75H18.75C19.1478 9.75 19.5294 9.90804 19.8107 10.1893C20.092 10.4706 20.25 10.8522 20.25 11.25V22.5H3.75V11.25C3.75 10.8522 3.90804 10.4706 4.18934 10.1893C4.47064 9.90804 4.85218 9.75 5.25 9.75H6.75V9C6.75 7.60761 7.30312 6.27226 8.28769 5.28769C9.27226 4.30312 10.6076 3.75 12 3.75C13.3924 3.75 14.7277 4.30312 15.7123 5.28769C16.6969 6.27226 17.25 7.60761 17.25 9V9.75ZM9.34835 6.34835C8.64509 7.05161 8.25 8.00544 8.25 9V9.75H15.75V9C15.75 8.00544 15.3549 7.05161 14.6517 6.34835C13.9484 5.64509 12.9946 5.25 12 5.25C11.0054 5.25 10.0516 5.64509 9.34835 6.34835ZM5.25 11.25V21H18.75V11.25H5.25ZM11.4697 13.7197C11.6103 13.579 11.8011 13.5 12 13.5C12.1989 13.5 12.3897 13.579 12.5303 13.7197C12.671 13.8603 12.75 14.0511 12.75 14.25V18.75H11.25V14.25C11.25 14.0511 11.329 13.8603 11.4697 13.7197Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.7b1646461f454315414789b0500d2c6a.svg";
export { ForwardRef as ReactComponent };